<template>
  <!-- 专家 -->
  <div class="specialist">
    <el-form-item
      label="所在医院"
      prop="json.hospital"
    >
      <el-input
        style="width:740px"
        type="text"
        v-model="ruleForm.json.hospital"
        autocomplete="off"
        placeholder="请输入所在医院"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="所属科室"
      prop="json.department"
    >
      <el-input
        style="width:740px"
        type="text"
        v-model="ruleForm.json.department"
        autocomplete="off"
        placeholder="请输入科室"
      ></el-input>
    </el-form-item>
    <el-form-item
      label="专家职称"
      prop="json.title"
    >
      <el-input
        style="width:740px"
        type="text"
        v-model="ruleForm.json.title"
        autocomplete="off"
        placeholder="请输入专家职称"
      ></el-input>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'specialist',
  props: ['ruleForm'],
  data () {
    return {
    }
  },
}
</script>
<style lang="less" scoped>
</style>